"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActivityFilter = void 0;
const common_1 = require("../common");
class ActivityFilter {
  _plugins;
  // eslint-disable-next-line no-useless-constructor
  constructor(_plugins) {
    this._plugins = _plugins;
  }
  _executePlugins(activities, groups, conditions, selected) {
    let list = [];
    this._plugins.forEach((plugin, index) => {
      if (typeof plugin.execute !== 'function') {
        throw new Error(`Plugin[${index}] must implement execute method`);
      }
      list = plugin.execute(list, activities, groups, conditions, selected);
    });
    return list;
  }
  getSelectedByActivityParticipantStatus(activities) {
    return activities.filter(a => {
      return [common_1.ActivityParticipantStatus.REGISTERED, common_1.ActivityParticipantStatus.WAITING_LIST, common_1.ActivityParticipantStatus.NO_SHOW, common_1.ActivityParticipantStatus.ARRIVED, common_1.ActivityParticipantStatus.PAYMENT_IN_PROGRESS, common_1.ActivityParticipantStatus.REGISTRATION_IN_PROGRESS, common_1.ActivityParticipantStatus.APPROVAL_PENDING].includes(a.activity_participant_status);
    }).map(a => a.id);
  }
  getSelectedByRenderAs(activities) {
    return activities.filter(a => {
      if (!a.renderas) {
        return [common_1.ActivityParticipantStatus.REGISTERED, common_1.ActivityParticipantStatus.WAITING_LIST, common_1.ActivityParticipantStatus.NO_SHOW, common_1.ActivityParticipantStatus.ARRIVED, common_1.ActivityParticipantStatus.PAYMENT_IN_PROGRESS, common_1.ActivityParticipantStatus.REGISTRATION_IN_PROGRESS, common_1.ActivityParticipantStatus.APPROVAL_PENDING].includes(a.activity_participant_status);
      }
      return [common_1.RenderAs.Registered, common_1.RenderAs.WaitingList, common_1.RenderAs.NoShow, common_1.RenderAs.Arrived, common_1.RenderAs.RegistrationInProgress, common_1.RenderAs.PaymentInProgress, common_1.RenderAs.RegistrationInProgress, common_1.RenderAs.ApprovalPending].includes(a.renderas);
    }).map(a => a.id);
  }
  createActivityList(activities, groups, conditions, selected) {
    return this._executePlugins(activities, groups, conditions, selected);
  }
  createActivitySelect(activities, groups, conditions, selected) {
    const list = this._executePlugins(activities, groups, conditions, selected);
    return this._formatActivitySelect(list, groups);
  }
  _formatActivitySelect(list, groups) {
    const select = [];
    const groupMap = new Map(groups.map(group => [group.id, group.name]));
    const map = new Map();
    for (const activity of list) {
      const group = activity.activity_group_id && groupMap.has(activity.activity_group_id) ? groupMap.get(activity.activity_group_id) : activity.name;
      map.set(group, (map.get(group) || []).concat(activity));
    }
    map.forEach((value, key) => {
      select.push({
        name: key,
        activities: value
      });
    });
    return select;
  }
}
exports.ActivityFilter = ActivityFilter;
